<template>
  <div class="v-table" :style="{ backgroundColor: bgColor }">
    <div class="v-table-body">
      <v-table-header/>
      <v-table-tr v-for="(d,i) in voucherDetailList"
                  @childNewSubject="newSubject"
                  @updateParentData="updateParentData"
                  :subjectList="subjectList"
                  :subjectMap="subjectMap"
                  :rowIndex="i"
                  :voucherDate="voucherDate"
                  :voucherDetailList="voucherDetailList"
                  :rowOperate="rowOperate"
                  :voucherDetail="d"/>
      <v-table-tr-total :detailList="voucherDetailList"/>
    </div>
  </div>
</template>

<script setup>
import VTableHeader from "@components/VoucherTable/VTableHeader.vue";
import VTableTr from "@components/VoucherTable/VTableTr.vue";
import {getCurrentInstance,defineProps, nextTick, onMounted, ref, watch} from "vue";
import {useStore} from "vuex";
import setting from "@api/setting";
import {ArrToObj} from "@js/common/utils";
import VTableTrTotal from "@components/VoucherTable/VTableTrTotal.vue";
import {add, floor, pick, subtract} from "xe-utils";
import EventBus from "@/js/common/EventBus";

const props = defineProps(['voucherDetails', 'isEdit', 'readonly','voucherDate','bgColor']);
const emits = defineEmits(['update',"edit-row"]);
const store = useStore();

const newEmptyRow = () => {
  return {
    summary: '',
    amountFor: null,
    debitAmount: null,
    debitAmountFor: 0,
    originalCreditAmount: 0,
    originalDebitAmount: 0,
    creditAmount: null,
    creditAmountFor: 0,
    subjectBalance: 0,
    subject: null,
    subjectId: null,
    auxiliary: [],
    currencyId: store.getters.localCurrency.id,
    num: 0,
    debitNum: 0,
    creditNum: 0,
    price: 0,
    exchangeRate: 0,
  };
}

const rowColRefs = {};
const subjectList = ref([]);
const subjectMap = ref({});
const voucherDetailList = ref([newEmptyRow(), newEmptyRow(), newEmptyRow(), newEmptyRow(), newEmptyRow()]);
const rowOperate = ref(false);//是否操作行jxd

const updateParentData = (newValue) => {  
  console.log("我也收到了")
  rowOperate.value = false;  
  console.log("改成false",rowOperate.value)
} 

const defaultList = () => {
  return [newEmptyRow(), newEmptyRow(), newEmptyRow(), newEmptyRow(), newEmptyRow()];
}

const newRow = (rowIndex) => {
  rowOperate.value = true;
  voucherDetailList.value.splice(rowIndex + 1, 0, newEmptyRow())
}

const loadSubject = () => {
  setting.subject.voucherSelect().then(({data}) => {
    subjectList.value = data;
    subjectMap.value = ArrToObj(data, val => val.id)
    voucherDetailList.value.forEach(vd => {
      if (vd.subjectId && !vd.subject) {
        vd.subject = subjectMap.value[vd.subjectId];
      }
    })
  })
}

loadSubject();

//jxd接收子组件的VTableTr添加科目成功的信息
const newSubject = (data) => {
  console.log(data)
  emits('childNewSubject', data);//向父组件发送添加科目成功事件
}

const rmRow = (rowIndex) => {
  rowOperate.value = true;
  console.log("移除行",rowIndex,voucherDetailList.value)
  if (voucherDetailList.value.length < 6) {
    // voucherDetailList.value.splice(rowIndex, 1, newEmptyRow())
    //在数组末尾加空行
    voucherDetailList.value.splice(rowIndex, 1)
    voucherDetailList.value.push(newEmptyRow());
  } else {
    voucherDetailList.value.splice(rowIndex, 1);
  }
}

watch(voucherDetailList, (val) => {
  // console.log(voucherDetailList)
  // console.log(voucherDetailList.value[voucherDetailList.value.length - 1])
  if(voucherDetailList.value[voucherDetailList.value.length - 1].subject != null){
    //最后一行不为空，自动添加空行jxd
    voucherDetailList.value.push(newEmptyRow());
  }
  // console.log(voucherDetailList)
  emits('update', val.filter(val => {
    return (val.debitAmount != null || val.creditAmount != null);
  }).map(value => {
    if (value.subject) {
      value.subjectId = value.subject.id;
      //传递下面几个数据，用于对损益类科目进行判断jxd
      value.subjectName = value.subject.name;
      value.subjectType = value.subject.type;
      value.balanceDirection = value.subject.balanceDirection;
    }
    return pick(value, Object.keys(value).filter(val => val !== 'subject'));
  }));
}, {deep: true})

watch(() => props.voucherDetails, (val) => {//
  let list = defaultList();
  (val || []).forEach((row, index) => {
    list[index] = row;
  })
  voucherDetailList.value = list;
})

onMounted(() => {
  let list = voucherDetailList.value;
  (props.voucherDetails || []).forEach((row, index) => {
    voucherDetailList.value[index] = row;
  })
  voucherDetailList.value = list;
})

EventBus.on("reloadSubject", loadSubject)

defineExpose({
  newRow,
  rmRow,
  loadSubject,
  getDetailList: () => {
    return voucherDetailList.value;
  },
  updateFiled: (rowIndex, col, val) => {
    if (val) {
      if (col === 'creditAmount') {
        voucherDetailList.value[rowIndex]['debitAmount'] = null;
      } else if (col === 'debitAmount') {
        voucherDetailList.value[rowIndex]['creditAmount'] = null;
      }
    }
    voucherDetailList.value[rowIndex][col] = val;
    //传递当前操作更新的下标给父组件jxd
    // emits('editRow', rowIndex);
    emits('edit-row', { rowIndex, rowData: voucherDetailList.value[rowIndex] });
  },
  next: (rowIndex, nextCol) => {
    const detail = voucherDetailList.value;
    if (rowColRefs[rowIndex]) {
      rowColRefs[rowIndex][nextCol].doEdit();
    } else {
      detail.push(newEmptyRow())
      nextTick(() => {
        rowColRefs[rowIndex][nextCol].doEdit();
      })
    }

    if (nextCol === 'summary') {
      //下一行自动平衡
      setTimeout(() => {
        if (detail[rowIndex - 1] && !detail[rowIndex].summary) {
          detail[rowIndex].summary = detail[rowIndex - 1].summary;
        }

        if (detail[rowIndex] && !(detail[rowIndex].debitAmount || detail[rowIndex].creditAmount)) {
          const totalDebit = detail.reduce((total, row) => add(total, (row.debitAmount || 0)), 0)
          const totalCredit = detail.reduce((total, row) => add(total, (row.creditAmount || 0)), 0)
          if (totalDebit !== totalCredit) {
            if (totalDebit > totalCredit) {
              detail[rowIndex].creditAmount = floor(subtract(totalDebit, totalCredit), 2);
            } else {
              detail[rowIndex].debitAmount = floor(subtract(totalCredit, totalDebit), 2);
            }
          }
        }
      }, 200)
    }
  },
  pushColInstance: (rowIndex, colRef) => {
    rowColRefs[rowIndex] = colRef;
  },
  autoEqAmount(rowIndex, field) { //等于号平衡
    const detail = voucherDetailList.value.filter((value, index) => index !== rowIndex);
    const totalDebit = detail.reduce((total, row) => add(total, (row.debitAmount || 0)), 0)
    const totalCredit = detail.reduce((total, row) => add(total, (row.creditAmount || 0)), 0)
    //置空自己
    if (field === 'debitAmount') {
      voucherDetailList.value[rowIndex]['creditAmount'] = null;
      voucherDetailList.value[rowIndex][field] = floor(subtract(totalCredit, totalDebit), 2);
    } else {
      voucherDetailList.value[rowIndex]['debitAmount'] = null;
      voucherDetailList.value[rowIndex][field] = floor(subtract(totalDebit, totalCredit), 2);
    }
  }
})
</script>

<style scoped lang="less">
.v-table {
  //background: @white-color;
  font-size: 12px;
  width: 100%;
  padding: 10px 20px;

  &-body {
    border: @border;
  }
}
</style>
